import { makeStyles } from "@material-ui/core/styles";

// The `Datagrid` component uses makeStyles, and supports overriding styles through the `classes` property
export default makeStyles((theme: any) => {
  return {
    rowOdd: {
      // backgroundColor: theme.palette.info.light,
    },
    headerCell: {
      // backgroundColor: theme.palette.grey[700],
      fontWeight: theme.typography.fontWeightBold,
      // color: "#f0f0f0",
    },
  };
});
